import { type WorkoutItemGroupType } from "api-client/legacy-trpc";
import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { DurationField } from "./DurationField";
import { SectionTypeField } from "./SectionTypeField";
import { useGroupUpdate } from "./useGroupUpdate";

interface AmrapHeaderFieldsProps {
  workoutItemId: string;
}

export const AmrapHeaderFields = observer(function AmrapHeaderFields(
  props: AmrapHeaderFieldsProps,
) {
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getGroupWorkoutItemById(
    props.workoutItemId,
  );
  const { handleUpdate } = useGroupUpdate(props.workoutItemId);

  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <div
      className="flex items-center gap-3 shrink-0"
      onClick={handleStopPropagation}
    >
      <SectionTypeField
        value={workoutItem.groupType}
        onChange={(value: WorkoutItemGroupType) => {
          handleUpdate({ groupType: value });
        }}
      />
      <DurationField
        value={workoutItem.durationMinutes}
        onChange={(value) => {
          handleUpdate({ durationMinutes: value });
        }}
      />
    </div>
  );
});
